import React from 'react'
import styled from 'styled-components'
import {Link} from 'gatsby'
import { ReactComponent as Instagram } from '../images/instagram.svg'
import { ReactComponent as Facebook } from '../images/facebook.svg'
import { ReactComponent as Pinterest } from '../images/pinterest.svg'


let FooterGroup = styled.div`
    position:relative;
    bottom: 10px;
    width:100vw;
    max-width:100%;
    background-color: #21D4FD;
    background-image: linear-gradient(210deg, #21D4FD 0%, #B721FF 100%);
    padding: 30px 0;
    display: grid;
    grid-gap: 15px;
`

const Text = styled.p`
    font-size: 1rem;
    font-weight: 600;
    color: white;
    max-width: 500px;
    margin: 0 auto;
    text-align: center;

    a {
        font-size: 1rem;
        font-weight: 500;
        margin: 5px 0;
        transition: 1s;
        color: #3FD0DB;
    }

    a:hover {
        color: white;
        cursor: pointer;
    }
`
const SocialIcons = styled.div`
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-gap: 10px;
    font-size: 24px;
    color: white;
    border: none;
    padding: 16px 60px;
    font-weight: 600;
    justify-self: center;
    transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
    z-index: 2;
svg{
    height:1.8rem;
    width:1.8rem;
}

    a:hover {
        height: 40px;
        border-radius: 90px;
        box-shadow: 0 20px 40px rgba(0,0,0, 0.15);
        transform: translateY(-3px);
    }
`

const Copyright = styled.div`
    color: white;
    max-width: 500px;
    margin: 0 auto;
    padding: 0 20px;
    font-size: .7rem;
    font-weight: 100;
    a {
        font-weight: 600;
        color: #3FD0DB;
    }

    a:hover {
        color: white;
        cursor: pointer;
    }
`

const Footer = ({ data }) => {
    // console.log(data);
    return (
        <FooterGroup>
            <Text>
                <a href={data.email}> Scrie-mi </a> dacă vrei să colaborăm sau ai întrebări. </Text>
            <SocialIcons >
                <a
                    href="https://www.facebook.com/ajutorulEducatorului"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Facebook />
                </a>
                <a
                    href="https://www.instagram.com/ajutorul_educatorului/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Instagram />
                </a>
                <a
                    href="https://ro.pinterest.com/ajutorulEducatorului/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Pinterest />
                </a>

            </SocialIcons>

            <Copyright>Created by <a href={data.siteUrl}> Ajutorul Educatorului © 2020 </a> </Copyright>
            <Copyright> <Link to='/gdpr'>
            GDPR </Link></Copyright>
            <Copyright>Sweet mood from
                <a href="http://www.roundbirds.com/"
                target="_blank"
                rel="noopener noreferrer"
            > Hyp </a> </Copyright>
        </FooterGroup>
    )

}

export default Footer;
